import React, { createContext, useContext, useState, useEffect } from 'react';

const StateContext = createContext();

export const useAppState = () => {
  const context = useContext(StateContext);
  return context;
};

export const AppStateProvider = ({ children }) => {
  // const [user, setUser] = useState(null);
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('user')) || null);

  const updateUser = (newValue) => {
    if (newValue === null) {
      localStorage.removeItem('user');
    } else {
      localStorage.setItem('user', JSON.stringify(newValue));
    }
    setUser(newValue);
  };

  // useEffect(() => {
  //   const storedUser = localStorage.getItem('user');
  //   if (storedUser) {
  //     setUser(JSON.parse(storedUser));
  //   }
  // }, [user]);

  return (
    <StateContext.Provider value={{ user, updateUser }}>
      {children}
    </StateContext.Provider>
  );
};
